import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem , TextField , Box } from "@mui/material";
import {AirportShuttle , History} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import "jspdf-autotable";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { useFormik, useField } from "formik";
import * as yup from "yup";
import _ from "lodash";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { CUSTOM_CONSTANTS } from "Constants/index";

//Services
import TriplistApi from "Services/Triplist";
import Passengerhistorydetails from "Pages/Modals/Passengerhistory/Moredetails";

const DriverReport = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);    
  const location = useLocation();
  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [moredetailsmodel, setmoredetailsModal] = useState(false);
  const Tripstatus = ["CANCELLED", "COMPLETED", "SCHEDULED"];
  const Paymentmethod = ["CASH", "CARD", "CORPORATE"];
  const [filtervalues , setFiltervalues] = useState({});
  const [requestId, setrequestId] = useState("");
   const [metrics,setmetrics] = useState({});
  const openaction = Boolean(anchorEl);
  const { driverRideId, driverId } = location.state || {};

  // Get Driver list api

  const gettriplists = useCallback(() => {
   // console.log('driverRideId--->',driverRideId);
   // console.log("driverId--->",driverId);
   // console.log('filtervalues-->',filtervalues);
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
       // console.log('rides of driver--->',res?.data);
        setRow(res?.data?.data?.data);
        setmetrics({
          kmdriven: res?.data?.data.kmdriven,
          duration: res?.data?.data.duration
        });
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getridesofdriver({ page, limit: pageSize , driver_ride_id:driverRideId, driver_id:driverId , filtervalues })
      .then(onSuccess, onFailure);
  }, [page, pageSize , filtervalues]);

  const getalltriplists = useCallback(() => {
   // console.log('driverRideId--->',driverRideId);
   // console.log("driverId--->",driverId);
   // console.log('filtervalues-->',filtervalues);
 //   dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
    //  dispatch(hideLoader());
      if (res?.data?.status === true) {
        setbulkrow(res?.data?.data?.data);
      } else {
        setbulkrow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    TriplistApi.getridesofdriver({ page:1, limit: "unlimited" , driver_ride_id:driverRideId, driver_id:driverId , filtervalues:"" })
      .then(onSuccess, onFailure);
  }, []);

  useEffect(() => {
    gettriplists();
    getalltriplists();
  }, [gettriplists]);

  const handleDownloadAll = () => {
    const csv = Papa.unparse(bulkformatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "All KmdrivenList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }; 

  const handleview = (event, rowData) => {
   // console.log('rowData-->',rowData)
    setrequestId(rowData?._id);
    setmoredetailsModal(true);
  };

  const handleClosemoredetailsModal = () => {
    setmoredetailsModal(false);
    gettriplists();
  };

  const handlePageChange = (newPage) => {
  //  console.log('newPage-->',newPage);
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };
  
  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };
 
  const handleCopy = () => {
    // Define column widths
    const columnWidths = [5, 15, 25, 15, 15, 15, 15]; // Adjust widths as needed
    // Helper function to pad text to the desired width
    const padText = (text, width) => {
      return (text ?? "").toString().padEnd(width, " ");
    };
    // Create table header
    const header = [
      padText("S.NO", columnWidths[0]),
      padText("Booking ID", columnWidths[1]),
      padText("KM driven", columnWidths[2]),
      padText("Duration", columnWidths[3]),
      padText("Earnings", columnWidths[4]),
      padText("Total", columnWidths[5])
    ].join("");
  
    // Create table rows
    const rows = dataRows
      .map((row) =>
        [
          padText(row.sno, columnWidths[0]),
          padText(row.bookingid, columnWidths[1]),
          padText(row.kmdriven+" KM", columnWidths[2]),
          padText(row.duration+" Mins", columnWidths[3]),
          padText("R "+row.earnings, columnWidths[4]),
          padText("R "+row.total, columnWidths[5])
        ].join("")
      )
      .join("\n");
  
    // Combine header and rows
    const formattedContent = [header, rows].join("\n");
  
    // Copy to clipboard
    navigator.clipboard.writeText(formattedContent).then(() => {
      alert("Table copied to clipboard!");
    });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "kMdriven_info.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "kMdriven_info.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,row.bookingid,row.kmdriven+" KM",
      row.duration+" Mins","R "+row.earnings,"R "+row.total,
]);
    doc.autoTable({
head: [["S.NO","Booking ID","KM driven","Duration","Earnings","Total"]],
body: tableData,
    });
    doc.save("kMdriven_info.pdf");
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    bookingid: data?.bookingId,
    earnings:data?.driverEarnings ? (data?.driverEarnings?.earnings ?? 0) :0,
    total:data?.estimatedFare||0,
    kmdriven:data?.tripDistance||0,
    duration:data?.tripMinutes||0,
    row: data,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex: 1,
      minWidth: 60, 
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "bookingid",
      headerName: "Booking ID",
      flex: 2,
      minWidth: 120, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.bookingid}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "kmdriven",
      headerName: "Km driven",
      flex: 2,
      minWidth: 120, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.kmdriven.toFixed(2)+" KM"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "duration",
      headerName: "Duration",
      flex: 2,
      minWidth: 120, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.duration.toFixed(2)+" mins"}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "earnings",
      headerName: "Earnings",
      flex: 2,
      minWidth: 120, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.earnings.toFixed(2)}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "total",
      headerName: "Total",
      flex: 2,
      minWidth: 190, 
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{CUSTOM_CONSTANTS.BASE_CURRENCY} {params?.row?.total.toFixed(2)}</Typography>
            </div>
          </>
        );
      },
    },
    {
        field: "actions",
        headerName: "Request Details",
        minWidth: 150, 
        resizable: true, 
        sortable: false,
        disableColumnMenu: true,
        renderCell: (params) => {
          const rowData = params?.row?.row;
          return (
            <>
        <div className={classes.iconsWrapper}>
        <Button
          id="basic-button"
          onClick={(e) => handleview(e, rowData)}
        >
          View
        </Button>
            </div>
            </>
          );
        },
    }
  ];

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking ID":row.bookingid,
    "KM driven": row.kmdriven+" KM",
    "Duration":row.duration+" Mins",
    "Earnings":"R "+row.earnings,
    "Total":"R "+row.total
  }));

  const bulkdataRows = _.map(
    _.orderBy(bulkrow || [], ['createdAt'], ['asc']),
    (data, index) => ({
       sno: calculateSno(page, pageSize, index),
    bookingid: data?.bookingId,
    earnings:data?.driverEarnings ? (data?.driverEarnings?.earnings ?? 0) :0,
    total:data?.estimatedFare||0,
    kmdriven:data?.tripDistance||0,
    duration:data?.tripMinutes||0,
    row: data,
  }));  
  
  const bulkformatteddatas = bulkdataRows.map((row) => ({
    "S.NO": row.sno,
    "Booking ID":row.bookingid,
    "KM driven": row.kmdriven+" KM",
    "Duration":row.duration+" Mins",
    "Earnings":"R "+row.earnings,
    "Total":"R "+row.total
  }));   

    // handle dates
  
  const handlefromdate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("fromdate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("fromdate", formattedDate);
    }
  };
  
  const handletodate = (newValue) => {
    if (newValue === null || newValue === "") {
      formik.setFieldValue("todate", newValue);
    } else {
      const selectedDate =
        newValue instanceof Date ? newValue : new Date(newValue);
      const parsedDate = moment(selectedDate);
      const formattedDate = parsedDate.format("MM/DD/YYYY HH:mm:ss");
      formik.setFieldValue("todate", formattedDate);
    }
  };
  
    // filter form 
  
    function convertToISO(inputDate) {
      if (!inputDate) {
        return "--"; // Handle null or undefined input
      }
    
      // Parse the input date string
      const date = new Date(inputDate);
    
      if (isNaN(date.getTime())) {
        return "--"; // Handle invalid date formats
      }
    
      // Convert to ISO string and replace "Z" with "+00:00" for UTC offset
      const isoString = date.toISOString().replace("Z", "+00:00");
      return isoString;
    }
    
  
  const handlefiltertriplist = (formValues) => {
     
    formValues.fromdate = convertToISO(formValues.fromdate);
    formValues.todate = convertToISO(formValues.todate);
   // console.log('formValues-->',formValues);
   // dispatch(showLoader("Loading please wait..."));
    setFiltervalues(formValues);
    };

   const formik = useFormik({
      initialValues: {
        tripStatus: "",
        paymentMode: "",
        fromdate: "",
        todate: "",
      },
      validationSchema: yup.object({
        fromdate: yup.string().required("Status is required").nullable(),
        todate: yup.string().required("Service is required").nullable(),
      }),
      enableReinitialize: true,
      onSubmit: async (values) => {
        handlefiltertriplist(values); // Ensure this processes `values` correctly
      },
    });

  return (  
    <>

<div className={classes.pages}>
<Grid container className={classes.root}>

<Grid container className={classes.metricboxes}>

<Grid item xs={6} className={classes.metricbox} >
<Box sx={{ background: '#fb9678' }}>
<Typography variant="h2">{metrics.kmdriven}</Typography>
<Typography variant="body2">KM DRIVEN</Typography>
<AirportShuttle/>
</Box>
</Grid>
<Grid item xs={6} className={classes.metricbox} >
<Box sx={{ background: '#00c292' }}>
<Typography variant="h2">{metrics.duration+" mins"}</Typography>
<Typography variant="body2">DURATION</Typography>
<History/>
</Box>
</Grid>

</Grid>

<Grid container className={classes.utilities}>

<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="tripStatus"
  id="tripStatus"
  select
  label="All status"
  value={formik?.values?.tripStatus || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus
  }
  helperText={
    formik?.errors?.tripStatus &&
    formik?.touched?.tripStatus &&
    formik?.errors?.tripStatus
  }
  fullWidth
  variant="outlined"
  size="small"
>
<MenuItem key="All status" value="">
    All Status
  </MenuItem> 
{Tripstatus.map((status) => (
  <MenuItem key={status} value={status}>
    {status}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.filters}>
<TextField
  name="paymentMode"
  id="paymentMode"
  select
  label="All Payment"
  value={formik?.values?.paymentMode || ""}
  onChange={formik?.handleChange}
  error={
    formik?.errors?.paymentMode &&
    formik?.touched?.paymentMode
  }
  helperText={
    formik?.errors?.paymentMode &&
    formik?.touched?.paymentMode &&
    formik?.errors?.paymentMode
  }
  fullWidth
  variant="outlined"
  size="small"
>
<MenuItem key="All payment" value="">
    All Payment
  </MenuItem>
{Paymentmethod.map((booking) => (
  <MenuItem key={booking} value={booking}>
    {booking}
  </MenuItem>
))}
</TextField>
</Grid>
<Grid item xs={3} md={3} lg={3} xl={3} className={classes.filters}>
  <div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="From Date"
  value={formik?.values?.fromdate || ""}
  size="small"
  onChange={(newValue) => {
  handlefromdate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate
    }
    helperText={
      formik?.errors?.fromdate &&
      formik?.touched?.fromdate &&
      formik?.errors?.fromdate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={3} md={3} lg={3} xl={3} className={classes.filters}>
<div className={classes.datePickerStyle}>
  <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
  label="To Date"
  value={formik?.values?.todate || ""}
  size="small"
  onChange={(newValue) => {
  handletodate(newValue);
  }}
  renderInput={(params) => (
  <TextField
    {...params}
    error={
      formik?.errors?.todate &&
      formik?.touched?.todate
    }
    helperText={
      formik?.errors?.todate &&
      formik?.touched?.todate &&
      formik?.errors?.todate
    }
  />
  )}
  />
  </LocalizationProvider>
  </div>
</Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.Endbtn}>
    <Button variant="contained" onClick={formik?.handleSubmit}>
      Filter
    </Button>
</Grid>

</Grid>

<Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleCopy}>
      COPY
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadExcel}>
      EXCEL
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadCSV}>
      CSV
    </Button>
  </Grid>
  <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
    <Button variant="contained" onClick={handleDownloadPDF}>
      PDF
    </Button>
  </Grid>
<Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
              <Button variant="contained" onClick={handleDownloadAll}>
              Download ALL
              </Button>
              </Grid>  
<Grid item xs={12}>
    <section className={classes.dataGridTable}>
      <DataGrid
       className={classes.tripgridtable}
        getRowId={(row) => row?.row?._id}
        rows={dataRows}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => {
         // console.log("newPageSize--->",newPageSize);
          setPageSize(newPageSize);
          setPage(1);
        }}
        onPageChange={(newPage) => handlePageChange(newPage)}
        rowsPerPageOptions={[5, 10, 25, 50]}
        pagination
        autoHeight={true}
        disableSelectionOnClick
        scrollbarSize={4}
        rowHeight={100}
        style={{ padding: "10px", borderRadius: "0px" }}
        paginationMode="server"
        rowCount={totalPages}
      />
    </section>
</Grid>

</Grid>
<Passengerhistorydetails
        openDialog={moredetailsmodel}
        id={requestId}
        handleClose={handleClosemoredetailsModal}
></Passengerhistorydetails>
</div>

    </>
  );
};

export default DriverReport;
